var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 75,
    viewBox: "0 0 90 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.75 51.5625H85.5V35.7275C85.5 33.8672 84.7828 32.0801 83.5172 30.7617L69.4688 16.1279C68.2031 14.8096 66.4875 14.0625 64.7016 14.0625H58.5V7.03125C58.5 3.14941 55.4766 0 51.75 0H6.75C3.02344 0 0 3.14941 0 7.03125V53.9062C0 57.7881 3.02344 60.9375 6.75 60.9375H9C9 68.7012 15.0469 75 22.5 75C29.9531 75 36 68.7012 36 60.9375H54C54 68.7012 60.0469 75 67.5 75C74.9531 75 81 68.7012 81 60.9375H87.75C88.9875 60.9375 90 59.8828 90 58.5938V53.9062C90 52.6172 88.9875 51.5625 87.75 51.5625ZM22.5 67.9688C18.7734 67.9688 15.75 64.8193 15.75 60.9375C15.75 57.0557 18.7734 53.9062 22.5 53.9062C26.2266 53.9062 29.25 57.0557 29.25 60.9375C29.25 64.8193 26.2266 67.9688 22.5 67.9688ZM67.5 67.9688C63.7734 67.9688 60.75 64.8193 60.75 60.9375C60.75 57.0557 63.7734 53.9062 67.5 53.9062C71.2266 53.9062 74.25 57.0557 74.25 60.9375C74.25 64.8193 71.2266 67.9688 67.5 67.9688ZM78.75 37.5H58.5V21.0938H64.7016L78.75 35.7275V37.5Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/delivery_icon.4ed85275e7c04bb4bf3895dabac09acc.svg";
export { ForwardRef as ReactComponent };